import { Blue } from "./Logo.Blue";
import { White } from "./Logo.White";
import { Black } from "./Logo.Black";
import { FullWhite } from "./Logo.FullWhite";
import { FullBlack } from "./Logo.FullBlack";

export const Logo = {
  Blue,
  White,
  Black,
  FullWhite,
  FullBlack,
};
